import { User } from '../interface/analytics.interface';

export const NonLoggedInUser: User = {
  attributes: {
    is_logged_in: 'unauthenticated',
    login_method: '',
    login_state: ''
  },
  profile: {
    skymiles_number: '',
    skymiles_tier: '',
    email: '',
    encrypted_email: '',
    email_domain: '',
    company_name: '',
    available_miles: '',
    amex_card_type: ''
  }
};

export const PAGE_LOAD_ERROR = {
  code: 'modal load error',
  message: 'modal load error'
};

export const USERNAME = 'username';
export const ACCOUNT = 'account';
export const ACCOUNT_TYPE = 'accountType';
export const MANAGE_TRIP_NAME = 'manage my trips';
export const PAGE_TYPE = 'trip details';
export const TRIP_DETAILS_ROUTE = 'trip-details';
export const MY_TRIPS_ROUTE = 'my-trips';
export const SUB_PAGE_TYPE = 'modal';
export const POP_UP = 'pop-up';
export const FLOW_TYPE = 'mytrip';
export const SUB_PAGE_LOAD = 'subPage load';
export const COLON_SYMBOL = ':';
export const CTA_CLICK = 'cta: click';
export const PAGE_PREFIX = 'dal';
export const EXTRA_SPACE = ' ';
export const FLIGHT = 'Flight';
export const MYTRIPS = 'mytrips';
